import React, { useState } from 'react';
import InfoIcon from '@heroicons/react/outline/InformationCircleIcon';
import { colorProductPrimaryHover } from '../../../styles/globalVariables';
import Modal from '../../shared/ModalPortal/Modal';
import { useTranslation } from 'react-i18next';

interface InfoPopoverProps {
  content: React.ReactNode;
  className?: string;
  customIcon?: any;
  popOverOnclick?: boolean;
  showModalHeader?: boolean;
  showCloseIcon?: boolean;
}

const InfoPopover: React.FC<InfoPopoverProps> = ({
  content,
  className = '',
  customIcon,
  popOverOnclick = false,
  showModalHeader = true,
  showCloseIcon = true
}) => {
  const { t } = useTranslation();

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isContentModelOpen, setIsContentModelOpen] = useState(false);

  const togglePopoverOn = () => {
    setIsPopoverOpen(true);
  };

  const togglePopoverOff = () => {
    setIsPopoverOpen(false);
  };

  const setOpenModel = () => {
    setIsContentModelOpen(true);
  };

  return (
    <>
      <div
        className={`relative inline-block ${className}`}
        onMouseEnter={!popOverOnclick ? togglePopoverOn : () => {}}
        onMouseLeave={!popOverOnclick ? togglePopoverOff : () => {}}
        onClick={popOverOnclick ? setOpenModel : () => {}}
      >
        <span className="cursor-pointer text-blue-500 hover:underline">
          {customIcon ? (
            customIcon
          ) : (
            <InfoIcon className="h-5 w-5" style={{ color: colorProductPrimaryHover }}></InfoIcon>
          )}
        </span>
        {isPopoverOpen && (
          <div className="absolute left-0 top-0 z-10 ml-2 mt-2 rounded-md border border-gray-300 bg-white p-2 shadow-lg">
            <div className="arrow absolute left-full top-0 h-4 w-4 -translate-y-1/2 rotate-45 bg-white"></div>
            {content}
          </div>
        )}
      </div>
      {isContentModelOpen && (
        <Modal
          showHeader={showModalHeader}
          showCloseIcon={showCloseIcon}
          width="62rem"
          headerText={''}
          toggleVisiblity={(value: boolean) => {
            setIsContentModelOpen(false);
          }}
          isVisible={true}
          overflowVisible={true}
          className=""
          //body={<NewQuestion editFromSurveyTemplate={true} questionId={editedQaId} />}
          body={typeof content === 'string' ? t(content) : content}
          primaryButtonText={t('T_TIMES_ICON_ALT_MSG')}
          primaryButtonWidth={'100px'}
          primaryOnClick={() => setIsContentModelOpen(false)}
        />
      )}
    </>
  );
};

export default InfoPopover;
